import React, { useContext, useState } from "react";
import { Button, Col, Row, Spin } from "antd";
import styles from "../../../camCaptureRecord/index.module.scss";
import AsideBlock from "../../../components/AsideBlock";
import { InvigilationCtx } from "../../../context";
import { getExamStudentMultiScreenInfo } from "../../../../../../service/exam";
import ShiftRecord from "../../../shiftBrowser/components/ShiftRecord";
import MultipleModal from "../../../camCaptureRecord/components/MultipleModal";
import useExamInfo from "../../../Hook/useExamInfo";

export default function AsideMultiple() {
    const [showModal, setShowModal] = useState(false);
    const { currentData } = useContext(InvigilationCtx);

    const [data, { loading }] = useExamInfo(
        getExamStudentMultiScreenInfo,
        currentData
    );

    return (
        <AsideBlock
            title="多屏记录"
            count={data?.multiScreenList?.length}
            extra={
                <Button
                    type="link"
                    className={styles.button}
                    onClick={() => setShowModal(true)}>
                    查看更多&gt;
                </Button>
            }>
            <Spin spinning={loading}>
                <Row type="flex">
                    {data?.multiScreenList?.slice(0, 6).map((item, index) => (
                        <Col key={index} span={8}>
                            <ShiftRecord {...item} />
                        </Col>
                    ))}

                    {data?.multiScreenList?.length === 0 && (
                        <Col span={24}>无多屏记录</Col>
                    )}
                </Row>
            </Spin>

            <MultipleModal
                visible={showModal}
                data={data?.multiScreenList || []}
                onCancel={() => setShowModal(false)}
            />
        </AsideBlock>
    );
}
